import React, { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import { Field, FormSpy } from "react-final-form";
import classNames from "classnames";
import { Checkmark, Warning } from "../icons";
import "./FormTextArea.css";

const MAX_LENGTH = 450;

const FormTextArea = forwardRef((props, ref) => {
  const id = `form-textarea--${props.name}`;
  const [numChars, setNumChars] = useState(0);

  return (
    <label
      htmlFor={id}
      className={classNames('form-textarea', props.className, {
        'form-textarea--disabled': props.disabled,
        'form-textarea--accept': props.accept,
        'form-textarea--reject': props.reject
      })}
    >
      {typeof props.labelRenderer === 'function' && props.labelRenderer()}
      <div className="form-textarea__container">
        <Field
          component="textarea"
          name={props.name}
          className="form-textarea__control"
          required={props.required}
          id={id}
          rows="4"
          ref={ref}
          initialValue={props.initialValue}
          placeholder={props.placeholder}
          value={props.value}
          disabled={props.disabled}
          maxLength={props.maxlength ? props.maxlength : MAX_LENGTH}
        />
        <div className="form-textarea__limit">{`${numChars} / ${props.maxlength ? props.maxlength : MAX_LENGTH}`}</div>
        {props.accept ? (
          <Checkmark
            className="form-textarea__icon"
            width="2.4rem"
            height="2.4rem"
          />
        ) : null}
        {props.reject ? (
          <Warning
            className="form-textarea__icon"
            width="2.4rem"
            height="2.4rem"
          />
        ) : null}
      </div>

      <FormSpy
        subscription={{ values: true }}
        onChange={({ values }) => {
          const content = values[props.name];
          setNumChars(content ? content.length : 0);
        }}
      />
    </label>
  );
});

FormTextArea.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  accept: PropTypes.bool,
  reject: PropTypes.bool,
  labelRenderer: PropTypes.func,
  className: PropTypes.string
};

FormTextArea.defaultProps = {
  required: false,
  placeholder: '',
  disabled: false,
  accept: false,
  reject: false,
  labelRenderer: undefined,
  className: null
};

export default FormTextArea;



// WEBPACK FOOTER //
// ./src/components/form/FormTextArea.js